import React, { useContext } from 'react';
import { GlobalContext } from 'shared/context/store';

export default (mapStateToProps, mapDispatchTopProps) => (WrappedComponent) => (props) => {
  const { state, dispatch } = useContext(GlobalContext);
  const mappedState = mapStateToProps(state);
  const mappedDispatch = {};
  for (let i = 0; i < Object.keys(mapDispatchTopProps).length; i += 1) {
    const idxItem = Object.keys(mapDispatchTopProps)[i];
    mappedDispatch[idxItem] = (...args) => mapDispatchTopProps[idxItem](...args)(dispatch, state);
  }
  const rest = {
    ...props,
    ...mappedState,
    ...mappedDispatch,
  };
  return (
    <WrappedComponent {...rest} />
  );
};
